import React, { useState } from "react";
import { RegisterUser } from "../firebase/auth";
import { reduxForm, Field, reset, formValueSelector } from "redux-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PasswordStrengthBar from "react-password-strength-bar";
import {
  Form,
  Button,
  Header,
  Grid,
  Segment,
  Message,
  Label,
} from "semantic-ui-react";
import { TextInput } from "../templates/utils/form-fields";
import "./app.css";

const selector = formValueSelector("registerForm");

let Register = ({ submitting, pristine, handleSubmit, invalid }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState();
  const [passwordScore, setPasswordScore] = useState(0);
  const password = useSelector((state) => selector(state, "password")) || "";

  const handleSubmitForm = (values) => {
    RegisterUser(
      values.email,
      values.password,
      `${values.firstName} ${values.lastName}`
    ).then(
      () => {
        navigate("/thankyou");
      },
      (error) => {
        setErrorMessage(error.message);
        dispatch(reset("registerForm"));
      }
    );
  };

  return (
    <Grid centered>
      <Grid.Column computer={4} tablet={8} mobile={16}>
        <Segment className="bm-auth">
          <Form onSubmit={handleSubmit(handleSubmitForm)}>
            <Header as="h3">Sign up</Header>
            <Field
              name="firstName"
              label="First name"
              component={TextInput}
              placeholder="First name"
            />
            <Field
              name="lastName"
              label="Last name"
              component={TextInput}
              placeholder="Last name"
            />
            <Field
              name="email"
              label="Email"
              type="email"
              component={TextInput}
              placeholder="joe@bloggs.com"
            />
            <div className="field">
              <Label ribbon className="register">
                Minimum 10 characters
              </Label>
              <Field
                name="password"
                label="Create password"
                type="password"
                component={TextInput}
                placeholder=""
              />
              <PasswordStrengthBar
                password={password}
                minLength={10}
                scoreWords={["weak", "okay", "good", "strong", "very strong"]}
                shortScoreWord="too short"
                onChangeScore={(score) => setPasswordScore(score)}
              />
              {password.length >= 10 && passwordScore < 3 && (
                <Label basic color="red" pointing>
                  Please choose a stronger password
                </Label>
              )}
            </div>
            <Field
              name="confirm"
              label="Confirm your password"
              type="password"
              component={TextInput}
              placeholder=""
            />
            <Button
              disabled={submitting || pristine || invalid || passwordScore < 3}
              positive
              type="submit"
              loading={submitting}
              size="tiny"
            >
              Submit
            </Button>
            {errorMessage && <Message negative content={errorMessage} />}
          </Form>
        </Segment>
      </Grid.Column>
    </Grid>
  );
};

const validate = (values) => {
  const testEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const errors = {};

  if (!values.firstName) errors.firstName = "Please enter your first name";

  if (!values.lastName) errors.lastName = "Please enter your last name";

  if (!values.email) {
    errors.email = "Please enter your email address";
  }

  if (values.email) {
    if (!testEmail(values.email)) {
      errors.email = "Please enter a valid email address";
    }
  }

  if (!values.password) {
    errors.password = "Please create a password";
  } else if (values.password.length < 10) {
    errors.password =
      "Please create a password of at least 10 characters. Include numbers, capital letters or special characters if needs be.";
  }

  if (!values.confirm) {
    errors.confirm = "Please confirm your password";
  } else if (values.password && values.confirm !== values.password) {
    errors.confirm = "Passwords don't match. Please enter the same password";
  }

  return errors;
};

Register = reduxForm({
  validate,
  form: "registerForm",
})(Register);

export default Register;
